<!-- 组件说明 -->
<template>
  <div class="">
    <div class="info formats" v-if="item['需求业态']">
      {{ item["需求业态"] }}
    </div>
    <div class="info area" v-if="item['需求面积']">{{ item["需求面积"] }}</div>
    <div class="info intention" style="margin:0" v-if="item['购房意向']">
      {{ item["购房意向"] }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    followItem: {
      type: Object,
    },
  },
  created() {},
  computed: {
    item() {
      let value = {};
      if (this.followItem.tagContents) {
        JSON.parse(this.followItem.tagContents).forEach((res) => {
          value[res.propertyName] = res.propertyValue;
        });
      }
      return value;
    },
  },
};
</script>

<style lang="scss" scoped>
.info {
  height: 48px;
  padding: 8px 12px 6px 12px;
  border-radius: 0px 12px 12px 12px;
  display: inline-block;
  margin-right: 12px;
  font-size: 24px;
  line-height: 34px;
  &.formats {
    background: #d8eee7;
    color: #007458;
  }
  &.area {
    background: #f6eed9;
    color: #d79414;
  }
  &.intention {
    background: #dde9f5;
    color: #5386b8;
  }
}
</style>
